.form {
  width: 100%;
}

.buttonWrapper {
  position: relative;
}

.buttonProgress {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
}

.prevButton {
  position: fixed;
  top: 10px;
  left: 10px;
}
